<div class="content">
  <div class="content-header">
    <div class="title-primary">{{'PatientDetailsPrimaryTitle' | cpLoginTranslate | async}}</div>
    <div class="title-secondary">{{'PatientDetailsSecondaryTitle' | cpLoginTranslate | async}}</div>

    <app-information-box class="information-box"
                [text1]="informationText1"
                [text2]="informationText2"
                [text3]="informationText3"
                [actionTextIndex]="informationActionTextIndex"
                [icon]="'pp-icon-info'"
                (onAction)="informationAction()">
    </app-information-box>
  </div>

  <app-web-form-light-container class="web-form"
                          *ngIf="showForm"
                          [URL]="patientDetailsURL"
                          #PatientDetailsForm
                          (dataValidated)="dataValidated($event)">
  </app-web-form-light-container>

  <div class="buttons-wrapper">
    <cp-button class="primary-button call-to-action" captionToTranslate="Continue.Login.PP" [disabled]="!patientDataValidated || continueClicked" (onClick)="continue()"></cp-button>
  </div>
</div>
